import { __ } from '@wordpress/i18n';
import StatCard from './StatCard';

/**
 * Stats Grid Component - Displays key metrics cards
 * @param {Object} statsData - Statistics data object
 */
const StatsGrid = ({ statsData }) => {
  const stats = [
    {
      title: __('Total Properties', 'havenlytics'),
      value: statsData.totalProperties,
      icon: 'building',
      category: 'properties',
      change: '+12%',
      changeType: 'positive'
    },
    {
      title: __('Published Property', 'havenlytics'),
      value: statsData.publishedProperties,
      icon: 'check-circle',
      category: 'published',
      change: '+8%',
      changeType: 'positive'
    },
    {
      title: __('Pending Property', 'havenlytics'),
      value: statsData.pendingProperties,
      icon: 'clock',
      category: 'pending',
      change: '+3%',
      changeType: 'positive'
    },
    {
      title: __('Expired Property', 'havenlytics'),
      value: statsData.expiredProperties,
      icon: 'times-circle',
      category: 'expired',
      change: '-5%',
      changeType: 'negative'
    },
    {
      title: __('Total Users', 'havenlytics'),
      value: statsData.totalUsers,
      icon: 'users',
      category: 'users',
      change: '+15%',
      changeType: 'positive'
    },
    {
      title: __('Block Users', 'havenlytics'),
      value: statsData.blockedUsers,
      icon: 'user-slash',
      category: 'blocked',
      change: '-2%',
      changeType: 'negative'
    },
    {
      title: __('Total Property Views', 'havenlytics'),
      value: statsData.totalPropertyViews.toLocaleString(),
      icon: 'eye',
      category: 'views',
      change: '+22%',
      changeType: 'positive'
    },
    {
      title: __('Total Favorites', 'havenlytics'),
      value: statsData.totalFavorites,
      icon: 'heart',
      category: 'favorites',
      change: '+18%',
      changeType: 'positive'
    },
    {
      title: __('Star Rating Properties', 'havenlytics'),
      value: statsData.totalStarRatings,
      icon: 'star',
      category: 'ratings',
      change: '+7%',
      changeType: 'positive'
    }
  ];

  return (
    <div className="hvnly-stats-grid">
      {stats.map((stat, index) => (
        <StatCard key={index} stat={stat} />
      ))}
    </div>
  );
};

export default StatsGrid;